import { NgModule } from '@angular/core';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class TaxRoutingModule {

}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/tax/tax-routing.module.ts